import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import { OK } from '@/common';
import { getEnterpriseIdentity } from '@/api/lawyerBoard';
export default /*#__PURE__*/_defineComponent({
  __name: 'IncomingEntry',
  setup(__props) {
    const RevenueKanbanManage = defineAsyncComponent(() => import('./index.vue'));
    const RevenueKanbanManageNew = defineAsyncComponent(() => import('@/views/revenueKanbanManageNew/index.vue'));
    /** 身份判定完成前不渲染任何一版看板，避免先渲染存量页再闪切 */
    const resolving = ref(true);
    const isEnterpriseAccount = ref(false);
    /** 企业账号主键，透传给企业版看板用于查自定义商店名，省掉一次重复的身份判定 */
    const enterpriseAccountId = ref('');
    const incomingComponent = computed(() => isEnterpriseAccount.value ? RevenueKanbanManageNew : RevenueKanbanManage);
    onMounted(async () => {
      try {
        const res = await getEnterpriseIdentity();
        if (res && res.code === OK) {
          isEnterpriseAccount.value = res.data.enterpriseAccount;
          enterpriseAccountId.value = res.data.enterpriseAccountId;
        }
      } catch (error) {
        // 判定失败按普通账号处理，回退存量收入看板，不阻断页面
        isEnterpriseAccount.value = false;
        enterpriseAccountId.value = '';
      } finally {
        resolving.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      return resolving.value ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        class: "incoming-entry-loading"
      })) : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(incomingComponent)), {
        key: 1,
        "enterprise-account-id": enterpriseAccountId.value
      }, null, 8, ["enterprise-account-id"]));
    };
  }
});